<nav class="navbar bg-transparent position-fixed top-0 start-0 w-100 py-3 z-3">
  <div class="container-fluid
              d-flex
              justify-content-center
              justify-content-md-start">

    <a
      href="#"
      class="navbar-brand brand-logo
             mx-auto
             mx-md-0
             m-0"
      aria-label="Home"
    ></a>

  </div>
</nav>
